var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconos(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 231,
    height: 25,
    viewBox: "0 0 231 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7_166)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M135.718 8.88889L134.116 10.4762C133.796 10.7936 133.396 10.7936 133.075 10.4762C126.349 4.36508 115.94 4.36508 109.215 10.4762C108.894 10.7143 108.494 10.7143 108.174 10.4762L106.572 8.88889C106.252 8.57143 106.252 8.09524 106.572 7.85714C114.739 0.396823 127.39 0.396823 135.557 7.85714C136.038 8.1746 136.038 8.65079 135.718 8.88889ZM130.513 14.127L128.912 15.7143C128.671 15.9524 128.191 16.0317 127.871 15.7143C124.027 12.3809 118.182 12.3809 114.339 15.7143C114.019 15.9524 113.618 15.9524 113.298 15.7143L111.697 14.127C111.377 13.8095 111.377 13.3333 111.697 13.0952C116.981 8.4127 125.068 8.4127 130.353 13.0952C130.833 13.3333 130.833 13.8095 130.513 14.127ZM124.108 19.7619C124.108 21.3492 122.826 22.6984 121.145 22.6984C119.544 22.6984 118.182 21.4286 118.182 19.7619C118.182 18.0952 119.464 16.8254 121.145 16.8254C122.826 16.8254 124.108 18.1746 124.108 19.7619Z",
    stroke: "#6F8A30",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.3037 11.8254V1.82538C27.3037 1.03173 26.6631 0.317444 25.7823 0.317444H3.84334C3.04265 0.317444 2.32202 1.03173 2.32202 1.82538V11.8254",
    stroke: "#6F8A30",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.3855 21.2698H0.320312V13.3333C0.320312 12.5397 0.960867 11.8254 1.84163 11.8254H27.8642C28.6649 11.8254 29.3855 12.4603 29.3855 13.3333V21.2698V21.2698Z",
    stroke: "#6F8A30",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8128 11.8254V9.20634C14.8128 7.46031 13.3716 6.03174 11.6101 6.03174H5.52479C3.76327 6.03174 2.32202 7.46031 2.32202 9.20634V11.8254",
    stroke: "#6F8A30",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.3037 11.8254V9.20634C27.3037 7.46031 25.8624 6.03174 24.1009 6.03174H18.0156C16.2541 6.03174 14.8129 7.46031 14.8129 9.20634V11.8254",
    stroke: "#6F8A30",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.9626 21.2698H0.320312V23.8889C0.320312 24.2857 0.64059 24.6825 1.12101 24.6825H2.24198C2.64232 24.6825 3.04267 24.3651 3.04267 23.8889V21.2698H2.9626Z",
    stroke: "#6F8A30",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.3854 21.2698H26.6631V23.8889C26.6631 24.2857 26.9834 24.6825 27.4638 24.6825H28.5848C28.9851 24.6825 29.3854 24.3651 29.3854 23.8889V21.2698Z",
    stroke: "#6F8A30",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.2704 10.2381H54.5272C53.8867 10.2381 53.3262 9.68253 53.3262 9.04761V2.30158C53.3262 1.50793 53.9667 0.79364 54.8475 0.79364H80.87C81.6707 0.79364 82.3913 1.42856 82.3913 2.30158V9.04761C82.3913 9.76189 81.9109 10.2381 81.2704 10.2381Z",
    stroke: "#6F8A30",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.5681 7.69843H80.2295",
    stroke: "#6F8A30",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.5698 16.6667C57.5698 18.4921 59.0911 19.9206 60.8527 19.9206C62.6142 19.9206 64.1355 18.4127 64.1355 16.6667V10.2381",
    stroke: "#6F8A30",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.2278 19.3651C78.2278 21.1905 76.7065 22.6191 74.945 22.6191C73.1034 22.6191 71.6621 21.1111 71.6621 19.3651V10.2381",
    stroke: "#6F8A30",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.8988 10.2381V24.127",
    stroke: "#6F8A30",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.843 19.2857H161.18C160.539 19.2857 159.979 18.7301 159.979 18.0952V4.12695C159.979 3.3333 160.619 2.61902 161.5 2.61902H187.522C188.323 2.61902 189.044 3.25394 189.044 4.12695V18.0952C188.964 18.7301 188.483 19.2857 187.843 19.2857Z",
    stroke: "#6F8A30",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.471 19.2857V22.3016",
    stroke: "#6F8A30",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.784 22.3016H182.158",
    stroke: "#6F8A30",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.279 6.19047L225.956 10.4762V22.619C225.956 23.4127 225.315 24.0476 224.514 24.0476H223.794C222.993 24.0476 222.353 23.4127 222.353 22.619V17.5397H221.632V22.619C221.632 23.4127 220.991 24.0476 220.191 24.0476H219.47C218.669 24.0476 218.029 23.4127 218.029 22.619V10.5555L213.705 6.26983C213.145 5.71428 213.145 4.76189 213.705 4.20634C214.266 3.65078 215.226 3.65078 215.787 4.20634L219.79 8.17459H224.434L228.438 4.20634C228.998 3.65078 229.959 3.65078 230.52 4.20634C230.84 4.68253 230.84 5.63491 230.279 6.19047ZM221.872 0.79364C223.714 0.79364 225.155 2.30158 225.155 4.04761C225.155 5.79364 223.634 7.30158 221.872 7.30158C220.031 7.30158 218.589 5.79364 218.589 4.04761C218.589 2.30158 220.031 0.79364 221.872 0.79364Z",
    stroke: "#6F8A30",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7_166"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 231,
    height: 25,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconos);
export default __webpack_public_path__ + "static/media/iconos.28c6a1036ffe305783bca9894d63a323.svg";
export { ForwardRef as ReactComponent };